import * as R from "ramda";

import { EndPoints } from "../../api-config";
import { pageLimit } from "../../paginations/paginationLimit";
let SERVER_ADDR_V1 = EndPoints.backendHost;

export const selfcareFilesUrl = (page, search, sortBy, sortDesc, operatorId, fromMeetingDate, toMeetingDate) =>
	`${SERVER_ADDR_V1}/selfcare/files?pagesize=${pageLimit}&pagenumber=${parseInt(page) - 1}${search === "" ? "" : "&textSearch=" + search}${sortBy === "" ? "" : "&sortBy=" + sortBy}${sortDesc === "" ? "" : sortDesc === "false" ? "&sortDesc=false" : "&sortDesc=true"}
	${operatorId !== "" ? "&operatorId=" + operatorId : ""}${fromMeetingDate !== "" && !R.isNil(fromMeetingDate) ? "&fromMeetingDate =" + fromMeetingDate : ""}${toMeetingDate !== "" && !R.isNil(toMeetingDate) ? "&toMeetingDate=" + toMeetingDate : ""}`;

export const selfcareFileByIdUrl = (id) => `${SERVER_ADDR_V1}/selfcare/files/${id}`;
